module.exports = __webpack_public_path__ + "img/fog.a164ff5e.png";